import PageWithHeaderLegacy from './PageWithHeaderLegacy';
import PageWithHeaderNew from './PageWithHeaderNew';

import { IPageProps } from '../LayoutPreference/layoutTypes';
import { useLayoutPreference } from '../LayoutPreference/useLayoutPreference';

/** @deprecated Temporary dual-layout rollout wrapper. Remove when legacy layout is retired. */
export default function PageWithHeader({
  children,
  tabs,
  title,
}: IPageProps & { children: React.ReactNode }): React.ReactElement {
  const { useNewLayout } = useLayoutPreference();

  return useNewLayout ? (
    <PageWithHeaderNew title={title} tabs={tabs}>
      {children}
    </PageWithHeaderNew>
  ) : (
    <PageWithHeaderLegacy title={title} tabs={tabs}>
      {children}
    </PageWithHeaderLegacy>
  );
}
